// import { useEffect, useState } from "react";
import styled from "styled-components";

import font from "src/styles/font";
import { UseUpload } from "src/context/UploadProductContext";

import AddIcon from "@mui/icons-material/Add";

import Button from "src/components/core/Button";

import MainProduct from "./ProductData/Main";
import ChoiceProduct from "./ProductData/Choice";

const Container = styled.div`
  width: 100%;
  max-width: 1240px;
  height: max-content;
  margin: 0 auto;
  padding: 36px 64px;
`;

const WrapperAddButton = styled.div`
  width: 100%;
  margin-top: 40px;
`;

const WrapperChoiceGrid = styled.div`
  width: 100%;
  margin-top: 40px;
`;

const Step1 = () => {
  const { dataUploadChoice, onAppendChoice } = UseUpload();

  return (
    <>
      <Container>
        <MainProduct />

        {/* map choices */}
        {dataUploadChoice?.length > 1 &&
          dataUploadChoice?.slice(1).map((_, index) => (
            <WrapperChoiceGrid key={`product-choice-${index}`}>
              <ChoiceProduct choiceIndex={index + 1} />
            </WrapperChoiceGrid>
          ))}

        {dataUploadChoice?.length < 10 ? (
          <WrapperAddButton>
            <Button
              variant="secondary"
              size="large"
              onClick={onAppendChoice}
              startIcon={<AddIcon />}
              sx={{
                // width: "100%",
                // maxWidth: 200,
                borderRadius: 4,
                fontSize: font.size.md,
              }}
            >
              เพิ่มตัวเลือกสินค้า
            </Button>
          </WrapperAddButton>
        ) : null}
      </Container>
    </>
  );
};

export default Step1;
